import { createRoot } from 'react-dom/client';
import StageMap from './StageMap';

// Entry: clone of interactive-map's bootstrap. Reads inputs from an inline JSON <script>
// (the ItineraryModule pattern, plan §5) — no API round-trip in v1.
const root = document.getElementById('tdu-stage-map-root');
const dataEl = document.getElementById('tdu-stage-map-data');

if (root) {
    let inputs = {};
    if (dataEl) {
        try {
            inputs = JSON.parse(dataEl.textContent || '{}');
        } catch {
            inputs = {};
        }
    }
    createRoot(root).render(<StageMap inputs={inputs} />);
}
